import styled from 'styled-components';
import Table from '@decisiv/ui-components/lib/components/Table';

import { CLAMPED_CELL_CLASS } from 'utils/tableColumnWidths';

/**
 * The KDS `Table` with the two rules every data table in the app relies on:
 *
 * 1. Header cells never wrap, so a label and its sort icon always stay on a
 *    single line (columns are given a `minWidth` wide enough to fit them — see
 *    `utils/tableColumnWidths`).
 * 2. A cell tagged with `CLAMPED_CELL_CLASS` clamps its content wrapper to the
 *    `--cell-max-width` published by the column, which is what lets long text
 *    truncate instead of widening the column. `min-width: 0` on the wrapper's
 *    own children lets a flex column inside the cell shrink far enough for the
 *    ellipsis to kick in, and the same on links and buttons lets a
 *    `TruncatedLabel` inside one of them shrink rather than push its control
 *    past the cell.
 */
const NoWrapHeaderTable = styled(Table)`
  && {
    table thead th div {
      white-space: nowrap;
    }

    table .${CLAMPED_CELL_CLASS} > div {
      box-sizing: border-box;
      max-width: var(--cell-max-width);
      overflow: hidden;
    }

    table .${CLAMPED_CELL_CLASS} > div > * {
      min-width: 0;
    }

    table .${CLAMPED_CELL_CLASS} > div a,
    table .${CLAMPED_CELL_CLASS} > div button {
      min-width: 0;
      max-width: 100%;
    }
  }
` as typeof Table;

export default NoWrapHeaderTable;
